import { Page, PageProps } from '../../page';

export const SettingsPage = ({ children, ...rest }: Omit<PageProps<true>, 'isSettingsPage'>) => {
  return (
    <Page isSettingsPage {...rest}>
      {children}
    </Page>
  );
};
